var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right_location_pin",
    transform: "translate(-435.5 -891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    transform: "translate(435.5 891)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pin_1_",
    "data-name": "pin (1)",
    d: "M26.7,6.1a6.1,6.1,0,1,0-6.508,6.081V23.593a.407.407,0,1,0,.814,0V12.183A6.1,6.1,0,0,0,26.7,6.1Zm-8.136,0a1.627,1.627,0,1,1,1.627-1.627A1.627,1.627,0,0,1,18.564,6.1Z",
    transform: "translate(436 900)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLocationPin);
export default __webpack_public_path__ + "static/media/right_location_pin.cf5d69302c77d15262533b38e081bef5.svg";
export { ForwardRef as ReactComponent };